export default __webpack_public_path__ + "static/media/GiftCard.58a3fe2e.svg";